// The words of «العقارات» (board 27 properties--consolidated) and of the hotel
// property switcher. Sector words (عقاراتي · عقار · كل العقارات) come from
// terminology; the rest are the board's. Display composition only — every
// number is the payload's.

import { arNumber } from '@/lib/format';
import { countLabel, type CountForms } from '@/lib/terminology';
import type { PropertyRow } from '../data/properties';
import { roomsLabel } from './words';

export const PROPERTIES_COPY = {
  /** The title while the owner reads every property: «كل العقارات · اليوم». */
  today: 'اليوم',
  current: 'الحالي',
  open: 'فتح',
  occupancy: 'الإشغال',
  adr: 'ADR',
  revenueToday: 'إيراد اليوم',
  report: 'تقرير مجمّع',
  shared: 'مشترك بين العقارات',
  permission: 'الصلاحية',
  /** The switcher's hint under «كل العقارات» (owner only). */
  allHint: 'عرض مجمّع للمالك',
  /** Undrawn: a payload with no properties. */
  none: 'لا عقارات بعد.',
  noneBody: 'تظهر هنا عقاراتك بعد إضافتها من الإعدادات.',
} as const;

const SUITES: CountForms = { one: 'جناح واحد', two: 'جناحان', few: 'أجنحة', many: 'جناحاً' };

/** «٤٨ غرفة + ٥ أجنحة» · «٢٤ غرفة» — the standard rooms, then the suites only when there are any. */
export function roomMix(p: Pick<PropertyRow, 'standard_rooms' | 'suites'>): string {
  const rooms = roomsLabel(p.standard_rooms);
  return p.suites > 0 ? `${rooms} + ${countLabel(p.suites, SUITES)}` : rooms;
}

/** The card's sub-line: «كربلاء · ٤٨ غرفة + ٥ أجنحة». */
export function propertySub(p: Pick<PropertyRow, 'city' | 'standard_rooms' | 'suites'>): string {
  return `${p.city} · ${roomMix(p)}`;
}

/** The switcher's sub-line: «كربلاء · ٥٣» (the city and the room count). */
export function switcherSub(city: string, rooms: number | undefined): string {
  return [city, rooms == null ? '' : arNumber(rooms)].filter(Boolean).join(' · ');
}

/** The head pill: «٧٧ غرفة · إشغال ٩٢٪» (the server's total). */
export function totalPill(total: { rooms: number; pct: number }): string {
  return `${roomsLabel(total.rooms)} · إشغال ${arNumber(total.pct)}٪`;
}
